import { MDBBtn, MDBChipsInput, MDBIcon } from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { editACDGroup, getMisc } from "../../../apiclients/streamsapi_bridge";
import { useNavigate } from "react-router";
import TelephoneNumbers from "../../TelephoneNumbers";

function GeneralACD({
  register,
  errors,
  setValue,
  selectedPhoneNum,
  setSuccessMessage,
  setError,
  clearErrors,
  acdcode,
  checkAvailable,
  setIsloading,
}) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [AddNumbers, setAddNumbers] = useState(false);
  const [checkAvailbility, setCheckAvailbility] = useState(false);
  const [freePhoneFlag, setfreePhoneFlag] = useState(true);
  const [sourceNumber, setSourceNumber] = useState([]);
  const [selectedPHnums, setSelectedPHnums] = useState([]);
  const [updatePHNum, setUpdatePHNum] = useState([]);
  const [updateNumbersExecuted, setUpdateNumbersExecuted] = useState(false);
  const [deleteNumberFlag, setDeleteNumberFlag] = useState(false);
  const [dbPhoneNumbers, setdbPhoneNumbers] = useState([]);

  useEffect(() => {
    if (selectedPhoneNum.length > 0) {
      setSelectedPHnums(selectedPhoneNum);
      setdbPhoneNumbers(selectedPhoneNum);
    }
  }, [selectedPhoneNum]);

  useEffect(() => {
    if (checkAvailable) {
      setCheckAvailbility(checkAvailable);
    }
  }, [checkAvailable]);

  useEffect(() => {
    if (freePhoneFlag) {
      getFreePhoneNumbers();
      setfreePhoneFlag(false);
    }
  }, [freePhoneFlag]);

  async function getFreePhoneNumbers() {
    let updates = {};
    console.log(sessionStorage.getItem("admin_session"));
    updates = {
      misc: ["free_dids"],
    };

    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      updates
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const basicInfo = await response.json();
    if (!basicInfo) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    console.log("response data is :::::::::: " + basicInfo);
    // alert(JSON.stringify(basicInfo.misc.free_dids))
    setSourceNumber(basicInfo.misc.free_dids);
  }

  useEffect(() => {
    if (updatePHNum.length > 0 && updateNumbersExecuted) {
      addPhoneNumbers("adddids");
      setUpdateNumbersExecuted(false);
    }
  }, [updatePHNum, updateNumbersExecuted]);

  useEffect(() => {
    if (updatePHNum.length > 0 && deleteNumberFlag) {
      addPhoneNumbers("removedids");
      setDeleteNumberFlag(false);
    }
  }, [updatePHNum, deleteNumberFlag]);

  async function addPhoneNumbers(fieldName) {
    setIsloading(true);
    let update = {
      reqid: 35,
      siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      code: acdcode,
      acd_general: {
        [fieldName]: updatePHNum,
      },
    };

    console.log(JSON.stringify(update));
    //alert(JSON.stringify(update));
    let saverep = await editACDGroup(update);
    console.log(saverep);
    let saverepeMsg = await saverep.json();
    //alert("response JSON ::: of update number ::::: " + JSON.stringify(saverepeMsg));

    if (saverepeMsg.status && saverepeMsg.status == "success") {
      if (fieldName === "adddids") {
        setSelectedPHnums((prev) => [...prev, ...updatePHNum]);
        setdbPhoneNumbers((prev) => [...prev, ...updatePHNum]);
        setSuccessMessage(`Telephone Number ${updatePHNum} added successfully.`); // success pop up message.
      } else {
        const updateAddPHNum = selectedPHnums.filter(
          (num) => !updatePHNum.includes(num)
        );
        setSelectedPHnums(updateAddPHNum);
        setdbPhoneNumbers(updateAddPHNum);
        setSuccessMessage(
          `Telephone Number ${updatePHNum} removed successfully.`
        ); // success pop up message.
      }
      setfreePhoneFlag(true);
    } else {
      if (fieldName === "removedids") {
        const modifynum = selectedPHnums.filter(
          (num) => !updatePHNum.includes(num)
        );
        setSelectedPHnums([...modifynum, ...updatePHNum]);
        setdbPhoneNumbers([...modifynum, ...updatePHNum]);
      }
    }
    setIsloading(false);
  }

  async function checkAvailability(e) {
    e.preventDefault();
    e.stopPropagation();
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { check_ext: parseInt(e.target.value) }
    );
    console.log(response);
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    if (tdata.check_ext) {
      setCheckAvailbility(true);
      setError("acd_general.extension", { message: "Extension is available" });
    } else {
      setCheckAvailbility(false);
      setError("acd_general.extension", { message: "Extension is not available" });
    }
    console.log(tdata);
  }

  return (
    <>
      <div className="margin-top huntgroup">
        <div className="general-settings">{t("general")}</div>
        <div className="add-numbermain">
          <div className="tel-numbers">{t("Name")}</div>
          <div className="d-flex w-30">
            <input
              type="text"
              {...register("acd_general.name", { required: "Name is required" })}
              className="form-control w-100"
            />
          </div>
        </div>

        <div className="add-numbermain">
          <div className="tel-numbers">{t("extension")}</div>
          <div className="d-flex w-30">
            <input
              className="w-100"
              type="text"
              maxLength={5}
              {...register("acd_general.extension", {
                setValueAs: (value) => Number(value),
                required: "Extension is required",
                minLength: {
                  value: 3,
                  message: "Extension must be at least 3 characters",
                },
                maxLength: {
                  value: 5,
                  message: "Extension must not exceed 5 characters",
                },
              })}
              onKeyPress={(event) => {
                if (!/[0-9]/.test(event.key)) {
                  event.preventDefault();
                }
              }}
              onChange={(e) => {
                if (e.target.value !== "") {
                  if (
                    e.target.value.length >= 3 &&
                    e.target.value.length <= 5
                  ) {
                    checkAvailability(e);
                  } else {
                    setCheckAvailbility(false);
                    clearErrors("acd_general.extension");
                  }
                  setValue("acd_general.extension", parseInt(e.target.value), {
                    shouldDirty: true,
                  });
                }
              }}
            />
            {errors?.acd_general?.extension && (
              <>
                {!checkAvailbility && (
                  <>
                    <p className="text-danger">
                      {errors?.acd_general?.extension?.message}
                    </p>
                  </>
                )}

                {checkAvailbility && (
                  <p style={{ color: "Green" }} className="clr-red">
                    {errors?.acd_general?.extension?.message}
                  </p>
                )}
              </>
            )}
          </div>
        </div>
        <TelephoneNumbers
          savedPhoneNumbers={selectedPHnums}
          setSavedPhoneNumbers = {setSelectedPHnums}
          setSuccessMessage={setSuccessMessage}
          uniqueid={acdcode}
          setUpdatePHNum={setUpdatePHNum}
          setUpdateNumbersExecuted={setUpdateNumbersExecuted}
          sourceNumber={sourceNumber}
          setDeleteNumberFlag={setDeleteNumberFlag}
          dbPhoneNumbers = {dbPhoneNumbers}
        />
        <div className="add-numbermain">
          <div className="tel-numbers">{t("location")}</div>
          <div className="phoneselect w-30">
            <select
              className="form-control form-select selectname w-100"
              name="San Jose"
            >
              <option value="San Jose">San Jose</option>
              <option value="San Jose">San Jose</option>
              <option value="San Jose">San Jose</option>
              <option value="San Jose">San Jose</option>
            </select>
          </div>
        </div>
        <div className="add-numbermain ">
          <div className="tel-numbers">{t("billing_Group")}</div>
          <div className="phoneselect w-30">
            <select
              className="form-control form-select selectname w-100"
              name="Default"
            >
              <option value="San Jose">{t("Default")}</option>
              <option value="San Jose">San Jose</option>
              <option value="San Jose">San Jose</option>
              <option value="San Jose">San Jose</option>
            </select>
          </div>
        </div>
      </div>
    </>
  );
}

export default GeneralACD;
